import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { PramsKeys } from 'src/types/type'

export const useSyncSentryUser = () => {
  const { requestID } = useParams<PramsKeys>()

  useEffect(() => {
    if (requestID) {
      Sentry.setUser({ id: requestID })
      return
    }
    Sentry.setUser(null)
  }, [requestID])
}